import { DefaultIcon } from '@summit/core';

import { SummitFormattedLine } from './summit-formatted-line';
import { SummitLink } from './summit-link';

export class SummitFormattedText {
  //For Typing Logic
  isFormattedText = true;
  ellipsisAfterLine: number | undefined;

  public lines = new Array<SummitFormattedLine>();

  public AddIcons(value: DefaultIcon[]) {
    const newLine = new SummitFormattedLine();
    newLine.iconArray = value;
    this.lines.push(newLine);
  }

  public AddLine(value: string | number, valueClass?: string[], urlTree?: Partial<SummitLink>, icon?: DefaultIcon) {
    const newLine = new SummitFormattedLine();
    newLine.iconLeft = icon;
    newLine.entry = value?.toString();
    newLine.link = new SummitLink(urlTree);
    if (valueClass) newLine.valueClass = valueClass;
    this.lines.push(newLine);
  }

  public AddHtml(value: string) {
    const newLine = new SummitFormattedLine();
    newLine.isHtml = true;
    newLine.entry = value;
    this.lines.push(newLine);
  }

  public AddHR() {
    this.AddLine('', ['flex', 'flex-row', 'border-t', 'border-gray-700', 'my-1', 'text-xs']);
  }

  public AddText(value: SummitFormattedText, valueClass?: string[]) {
    if (value?.lines?.length > 0) {
      if (!valueClass) {
        this.lines.push(...value.lines);
      } else {
        value.lines.forEach((x) => {
          if (x.valueClass) x.valueClass.push(...valueClass);
          else x.valueClass = valueClass;
          this.lines.push(x);
        });
      }
    }
  }

  public AddKeyValues(key: string, value: string | number, valueClass?: string[], icon?: DefaultIcon) {
    const newLine = new SummitFormattedLine();
    newLine.iconLeft = icon;
    newLine.SetKeyValues(key, value);
    if (valueClass) newLine.valueClass = valueClass;
    this.lines.push(newLine);
  }

  public RemoveZeroValues() {
    this.lines = this.lines.filter((x) => x.value != '0');
  }

  public SortAlphabetically() {
    this.lines = this.lines.sort((a, b) => {
      const aItem = a.key ?? a.entry;
      const bItem = b.key ?? b.entry;
      return aItem.localeCompare(bItem);
    });
  }

  public isEmpty() {
    return this.lines.length == 0;
  }

  public toString(): string {
    return this.lines
      .filter((x) => !x.iconArray)
      .map((x) => (x.key ? `${x.key}: ${x.value}` : x.entry))
      .join(', ');
  }

  public toExcelString(): string {
    return this.lines
      .filter((x) => !x.iconArray)
      .map((x) => (x.key ? `${x.key}: ${x.value}` : x.entry))
      .join('\n');
  }

  public toFilterValues(): string[] {
    return this.lines.filter((x) => !x.iconArray).map((x) => (x.key ? x.key : x.entry));
  }
}
